<app-header-page>
    <h1>{{ 'HEADERS.FACTORING' | translate }}</h1>
</app-header-page>

<app-contract-table-mt></app-contract-table-mt>
